import { render } from "./regionManage.vue?vue&type=template&id=625d6fa2&scoped=true"
import script from "./regionManage.vue?vue&type=script&lang=js"
export * from "./regionManage.vue?vue&type=script&lang=js"

import "./regionManage.vue?vue&type=style&index=0&id=625d6fa2&lang=scss"
import "./regionManage.vue?vue&type=style&index=1&id=625d6fa2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-625d6fa2"

export default script